[
  {
    "minLevel": 1,
    "maxLevel": 19,
    "requirement": 3,
    "rewardGems": 200
  },
  {
    "minLevel": 20,
    "maxLevel": 49,
    "requirement": 5,
    "rewardGems": 200
  },
  {
    "minLevel": 50,
    "maxLevel": 99,
    "requirement": 7,
    "rewardGems": 200
  },
  {
    "minLevel": 100,
    "requirement": 9,
    "rewardGems": 200
  }
]
